module.exports = __webpack_public_path__ + "static/media/bts_carassauga_180526_003_small.1054f69e.jpg";